// extracted by mini-css-extract-plugin
export var infoRow = "_r1-2";
export var labelContainer = "_r1-0";
export var rightInfo = "_r1-1";